import moment from "moment";
import { useState } from "react";

const now = moment();

export default function useMonthYear(initialMonth: number = now.month(), initialYear: number = now.year()) {
    const [month, setMonth] = useState<number>(initialMonth);
    const [year, setYear] = useState<number>(initialYear);

    return {
        month,
        setMonth,
        year,
        setYear
    };
}